import { ATTACHMENT_KIND } from './sheet-sections.js';
/** Work-document originals accompany factory packets; QC and internal attachments remain outside the packet. */
export const FACTORY_ATTACHMENT_KINDS = [
    ATTACHMENT_KIND.FLAT_SKETCH, ATTACHMENT_KIND.DETAIL_IMAGE, ATTACHMENT_KIND.FG_IMAGE, ATTACHMENT_KIND.DESIGN_SOURCE,
    ATTACHMENT_KIND.SUB_MATERIAL_IMAGE, ATTACHMENT_KIND.LABEL_SEWING, ATTACHMENT_KIND.SHIPPING,
    ATTACHMENT_KIND.SHIP_TAGGING, ATTACHMENT_KIND.SHIP_BOXING, ATTACHMENT_KIND.SHIP_FOLDING, ATTACHMENT_KIND.SHIP_IRON, ATTACHMENT_KIND.PATTERN_SPEC_IMAGE,
];
export function isFactoryPreviewImage(file) {
    return !/\.(ai|eps|dxf|dwg|plt)$/i.test(file.fileName)
        && ['image/png', 'image/jpeg', 'image/webp', 'image/gif', 'image/svg+xml', 'image/bmp', 'image/avif'].includes(file.mimeType.toLowerCase());
}
/** Only images declared by the frozen document enter the image loader; source PDFs/AI/CAD are downloaded on demand. */
export function factoryPreviewFiles(files, snapshot) {
    const images = new Set(snapshot.sheet.attachments.map(file => file.id));
    return files.filter(file => images.has(file.sourceId) && isFactoryPreviewImage(file));
}
//# sourceMappingURL=factory-files.js.map